import { createApi } from "@reduxjs/toolkit/query/react"
import { authQuery } from "./authQuery"
import { ValidationErrorResponse } from "@custom-types/common"

export type PostDashboardFilePayload = {
  data: File
  nodes: string[] // labels
  graph_id: string
}

type PostDashboardFileResponse =
  | SuccessfullPostDashboardFileResponse
  | ErrorPostDashboardFileResponse

type SuccessfullPostDashboardFileResponse = {
  dashboard_hash: string
  path: string
  message: string
}

type ErrorPostDashboardFileResponse = {
  message: string
}

export const dashboardApi = createApi({
  reducerPath: "dashboardApi",
  baseQuery: authQuery,
  tagTypes: ["dashboard"],
  endpoints: (builder) => ({
    getGraphDashboard: builder.query<string, string>({
      query: (key) => ({
        url: `/graphs/${encodeURIComponent(key)}/dashboard_file`,
      }),
      providesTags: ["dashboard"],
    }),
    getGraphDashboardFile: builder.query<string, string>({
      query: (key) => ({
        url: `/editor/dashboard?graph_id=${encodeURIComponent(key)}`,
      }),
      providesTags: ["dashboard"],
    }),
    postDashboardFile: builder.mutation<PostDashboardFileResponse, PostDashboardFilePayload>({
      query: (payload) => {
        const formData = new FormData()
        formData.set("data", payload.data)

        if (payload.nodes) formData.set("nodes", JSON.stringify(payload.nodes))
        if (payload.graph_id) formData.set("graph_id", payload.graph_id)

        return {
          url: "/document/upload-dashboard-document",
          method: "POST",
          body: formData,
        }
      },
      invalidatesTags: ["dashboard"],
    }),
    deleteDashboardFile: builder.mutation<ValidationErrorResponse | string, string>({
      query: (payload) => {
        return {
          url: `/editor/dashboard?graph_id=${encodeURIComponent(payload)}`,
          method: "DELETE",
        }
      },
      invalidatesTags: [], // do not invalidate here, since on upload we need to delete+upload on dashboard configuration use dispatch manually
    }),
  }),
})

export const {
  useGetGraphDashboardQuery,
  useGetGraphDashboardFileQuery,
  useLazyGetGraphDashboardQuery,
  usePostDashboardFileMutation,
  useDeleteDashboardFileMutation,
} = dashboardApi
